import React, { Component } from "react";
import { Form } from "react-form";

import InputText from "components/form-fields/InputText";
import TextArea from "components/form-fields/TextArea";
import Select2 from "components/form-fields/Select2";
import Select from "components/form-fields/Select";
import FormMessage from "components/FormMessage";
import {
  storageOptions,
  productViews,
  smsProviders,
  featureOptions
} from "./constants";

export default class extends Component {
  onSubmit = data => {
    this.props.handleFormSubmit(data);
  };

  urlValidator(value) {
    const regx = /^[a-z0-9]+(?:-+[a-z0-9]+)*$/;
    const message =
      "must be lowercase and may only contain letters, numbers, and separating words with dashes.";
    return {
      error: value && !regx.exec(value) ? message : null
    };
  }

  render() {
    const {
      props: { defaultValues, rateLimits, availableGateways }
    } = this;

    return (
      <Form onSubmit={this.onSubmit} defaultValues={defaultValues}>
        {formApi => (
          <form onSubmit={formApi.submitForm}>
            <div className="box">
              <div className="columns">
                <div className="column">
                  <InputText
                    field="sm3_id"
                    label="Sm3 ID"
                    type="text"
                    placeholder="Sm3 ID"
                  />
                </div>
                <div className="column">
                  <InputText
                    field="parent_id"
                    label="Parent ID"
                    placeholder="Parent ID"
                  />
                </div>
              </div>
              <div className="columns">
                <div className="column">
                  <InputText
                    required
                    field="name"
                    label="Name"
                    placeholder="Name"
                  />
                </div>
                <div className="column">
                  <InputText
                    required
                    field="unicode_name"
                    label="Unicode Name"
                    placeholder="Unicode Name"
                  />
                </div>
                <div className="column">
                  <InputText
                    field="url"
                    label="URL"
                    placeholder="URL"
                    validate={this.urlValidator}
                  />
                  <FormMessage
                    show={formApi.errors && formApi.errors.url}
                    colorClass={"is-danger"}
                    message={formApi.errors && formApi.errors.url}
                  />
                </div>
              </div>

              <div className="columns">
                <div className="column">
                  <InputText
                    required
                    type="email"
                    field="admin_email"
                    label="Admin email"
                    placeholder="Admin email"
                  />
                </div>

                <div className="column">
                  <InputText
                    field="expired_at"
                    label="Expired at"
                    type="date"
                    placeholder="Expired at"
                  />
                </div>
              </div>
              <div className="columns">
                <div className="column">
                  <Select
                    field="disk_capacity"
                    label="Disk capacity"
                    placeholder="Disk capacity"
                    options={storageOptions}
                    key="value"
                  />
                </div>
              </div>
              <div className="columns">
                <div className="column">
                  <InputText
                    field="user_limit"
                    label="Number of Users"
                    type="number"
                    placeholder="Number of Users"
                  />
                </div>
              </div>
              <div className="columns">
                <div className="column">
                  <Select
                    field="rate_limit"
                    label="Rate Limits"
                    placeholder="Rate Limits"
                    options={rateLimits.data}
                    key="value"
                  />
                </div>
                <div className="column">
                  <Select2
                    field="available_gateways"
                    label="Available Gateways"
                    placeholder="Available Gateways"
                    options={availableGateways.data}
                    getOptionLabel={o => o.title}
                    getOptionValue={o => o.name}
                    defaultValue={availableGateways.data.filter(
                      o =>
                        defaultValues &&
                        defaultValues.available_gateways &&
                        defaultValues.available_gateways.includes(o.id)
                    )}
                    onChange={values => {
                      formApi.setValue(
                        "available_gateways",
                        values.map(v => v.id)
                      );
                    }}
                    isMulti
                  />
                </div>
              </div>
              <div className="columns">
                <div className="column">
                  <Select
                    field="product_view"
                    label="Product View"
                    placeholder="Product View"
                    options={productViews}
                    key="value"
                  />
                </div>
              </div>
              <div className="columns">
                <div className="column">
                  <Select
                    field="sms_provider"
                    label="SMS Provider"
                    placeholder="SMS Provider"
                    options={smsProviders}
                    key="value"
                  />
                </div>
                <div className="column">
                  <InputText
                    field="sms"
                    label="SMS Sender ID"
                    placeholder="SMS Sender ID"
                  />
                </div>
                <div className="column">
                  <InputText
                    field="sms_api_token"
                    label="SMS API Token"
                    placeholder="SMS API Token"
                  />
                </div>
              </div>
              <div className="columns">
                <div className="column">
                  <TextArea
                    field="other_settings.fcm.key"
                    label="Push Notification Key"
                    placeholder="Push Notification Key"
                  />
                </div>
              </div>
              <div className="columns">
                <div className="column">
                  <Select2
                    field="features"
                    label="Available Features"
                    placeholder="Available Features"
                    options={featureOptions}
                    defaultValue={featureOptions.filter(
                      o =>
                        defaultValues &&
                        defaultValues.features &&
                        defaultValues.features.includes(o.value)
                    )}
                    onChange={values => {
                      formApi.setValue(
                        "features",
                        values.map(v => v.value)
                      );
                    }}
                    isMulti
                  />
                </div>
              </div>
            </div>

            <button className="button is-fullwidth is-info is-medium">
              Submit
            </button>
          </form>
        )}
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Company/Form.js